import {clone, denseRank, getAscendants, getSSID, removeItem, sortKeys, isOffline} from './utils';
import store from '@/js/store.js';

let ssid = getSSID();

export function hasAccessTo(userRightList, rightId, options = {}) {
  if(isOffline()) return true;
  //console.log('checking rights...', 'rightId: ' + rightId, ', moduleId: ' + moduleId, ', documentCategoryId: ' + documentCategoryId, ', documentTypeId: ' + documentTypeId, ', documentId: ' + documentId, ', organizationIds: ' + organizationIds, ', parentDocumentId: ' + parentDocumentId)
  if (!rightId) return false;

  const defaultOptions = {
    moduleId: null,
    documentCategoryId: null,
    documentTypeId: null,
    documentId: null,
    documentIds: null,
    organizationIds: null,
    parentDocumentId: null,
    isPrivate: false
  }

  options = {
    ...defaultOptions,
    ...options
  }

  let userRights = [];
  userRightList.forEach(x => {
    userRights.push(clone(x))
  })

  let documentCategoryIds, documentTypeIds;
  if (options.documentCategoryId)
    if (store && store.state && store.state[ssid] && store.state[ssid].common && store.state[ssid].common.documentCategories) {
      let documentCategoryAscendants = getAscendants(store.state[ssid].common.documentCategories, options.documentCategoryId, 'documentCategoryId', 'parentDocumentCategoryId', []);
      if (documentCategoryAscendants)
        documentCategoryIds = documentCategoryAscendants.map(x => x.documentCategoryId);

    } else documentCategoryIds = [options.documentCategoryId]

  if (options.documentTypeId)
    if (store && store.state && store.state[ssid] && store.state[ssid].common && store.state[ssid].common.documentTypes) {
      let documentTypeAscendants = getAscendants(store.state[ssid].common.documentTypes, options.documentTypeId, 'documentTypeId', 'parentDocumentTypeId', []);
      if (documentTypeAscendants)
        documentTypeIds = documentTypeAscendants.map(x => x.documentTypeId);
    } else documentTypeIds = [options.documentTypeId];

  let userHasRight = false

  if (userRights && userRights.length) {
    userRights = userRights.filter(x =>
      (!options.organizationIds || !x.organizationId || (x.organizationId && options.organizationIds && options.organizationIds.includes(x.organizationId)))
      &&
      (!options.moduleId || !x.moduleId || (x.moduleId && options.moduleId && x.moduleId === options.moduleId))
      &&
      (!documentCategoryIds || !x.documentCategoryId || (x.documentCategoryId && documentCategoryIds && documentCategoryIds.includes(x.documentCategoryId)))
      &&
      (!documentTypeIds || !x.documentTypeId || (x.documentTypeId && documentTypeIds && documentTypeIds.includes(x.documentTypeId)))
      &&
      (!options.documentId || !x.documentId || (x.documentId && options.documentId && (x.documentId === options.documentId || (options.parentDocumentId && options.parentDocumentId === x.documentId))))
      &&
      (x.rightIds && x.rightIds.length)
      &&
      ((!options.isPrivate && !x.isPrivate ) || (x.isPrivate && options.isPrivate && x.isPrivate === options.isPrivate))
      &&
      (!options.documentIds || !x.documentIds || (x.documentIds && options.documentIds && options.documentIds.every(value => x.documentIds.includes(value))))
    )

    let result;

    if (userRights) {
      result = userRights.slice();

      if (documentCategoryIds)
        result.forEach(element => {
          if (element.documentCategoryId)
            element.documentCategoryPosition = documentCategoryIds.findIndex(x => x === element.documentCategoryId)
        });
      if (documentCategoryIds)
        result.forEach(element => {
          if (element.documentTypeId)
            element.documentTypePosition = documentTypeIds.findIndex(x => x === element.documentTypeId)
        });

      let sortList = {
        "userId": "asc",
        "documentId": "asc",
        "documentCategoryId": "asc",
        "documentTypeId": "asc",
        "roleId": "asc",
        "moduleId": "asc",
        "organizationId": "asc"
      }

      if (documentCategoryIds && documentTypeIds)
        sortList = {
          "userId": "asc",
          "documentId": "asc",
          "documentCategoryPosition": "asc",
          "documentTypePosition": "asc",
          "roleId": "asc",
          "moduleId": "asc",
          "organizationId": "asc"
        }
      else if (documentCategoryIds)
        sortList = {
          "userId": "asc",
          "documentId": "asc",
          "documentCategoryPosition": "asc",
          "documentTypeId": "asc",
          "roleId": "asc",
          "moduleId": "asc",
          "organizationId": "asc"
        }
      else if (documentTypeIds)
        sortList = {
          "userId": "asc",
          "documentId": "asc",
          "documentCategoryId": "asc",
          "documentTypePosition": "asc",
          "roleId": "asc",
          "moduleId": "asc",
          "organizationId": "asc"
        }

      result = sortKeys(result, sortList);

      let groupBy = ["organizationId", "moduleId", "roleId", "documentCategoryId", "documentTypeId", "documentId"]
      if (documentCategoryIds)
        groupBy = removeItem(groupBy, "documentCategoryId");
      if (documentTypeIds)
        groupBy = removeItem(groupBy, "documentTypeId");
      result = denseRank(result, groupBy)
      //console.log((result ? result.length : null) + ' ' + (result && result.length ? result[0].priority : null))
      result = result.filter(x =>
        x && x.priority && x.priority === 1 && (!rightId || !x.rightIds || (x.rightIds && rightId && x.rightIds.find(r => rightId === r)))
      )

    }

    userHasRight = result && result.length > 0
  }

  //console.log('access result', userHasRight, userRights)

  return userHasRight
}

export function getModulesTree(modulesList) {
  let modules = []
  if (modulesList) {
    let sortedModules = modulesList.sort(
      (a, b) => (a.parentModuleId > b.parentModuleId) ? 1 : ((b.parentModuleId > a.parentModuleId) ? -1 : 0)
    )
    for (let x = 0; x < sortedModules.length; x++) {
      const module = sortedModules[x]
      if (!module.parentModuleId) {
        modules.push({
          ...module,
          children: []
        })
      } else {
        const parentModule = modules.findIndex(
          pm => pm.moduleId === module.parentModuleId
        )
        if (parentModule > -1) {
          modules[parentModule].children.push({
            ...module,
            children: []
          })
        }
      }
    }
  }
  return modules
}

function modulesListToPrimeTree(list) {
  return list.map(node => {
    let children = [];
    if (node.children && node.children.length) {
      children = modulesListToPrimeTree(node.children)
    }
    return {
      key: node.moduleId,
      label: node.title,
      data: {
        title: node.title,
        description: node.description,
        rightIds: node.rightIds,
        parentModuleId: node.parentModuleId,
        timestamp: node.timestamp,
      },
      children
    }
  });
}

export function getModulesTreeNode(modulesList) {
  return modulesListToPrimeTree(getModulesTree(modulesList));
}

export function getModuleIdStrict(moduleName, modules = []) {
  if (modules) {
    if (!moduleName) return null;
    if (typeof moduleName === 'number') return moduleName;
    const module = modules.find(m => m.code.toLowerCase() === moduleName.toLowerCase());
    if (module) return module.moduleId;
    else return null;
  }
}

export function getModuleId(moduleName, modules = []) {
  if (modules) {
    if (!moduleName) return null
    if (typeof moduleName === 'number') return moduleName

    const module = modules.find(
      m => new RegExp(`^${moduleName}$`, 'gi').test(m.code)
    )
    if (module) {
      return module.moduleId
    } else {
      return null
    }
  } else {
    return null
  }
}

export function getRightId(rightName, rightsList = []) {
  if (rightsList) {
    if (!rightName) return null
    if (typeof rightName === 'number') return rightName

    const right = rightsList.find(
      r => new RegExp(`^${rightName}$`, 'gi').test(r.code)
    )
    if (right) {
      return right.rightId
    } else {
      return null
    }
  } else {
    return null
  }
}

export function getDocumentCategoryId(category, documentCategories = []) {
  if (documentCategories) {
    if (!category) return null
    if (typeof category === 'number') return category

    const categ = documentCategories.find(
      c => new RegExp(category, 'gi').test(c.title)
    )
    if (categ) {
      return categ.documentCategoryId
    } else {
      return null
    }
  } else {
    return null
  }
}

export function getDocumentTypeId(type, documentTypes = []) {
  if (documentTypes) {
    if (!type) return null
    if (typeof type === 'number') return type

    const dType = documentTypes.find(
      t => new RegExp(type, 'gi').test(t.title)
    )
    if (dType) {
      return dType.documentTypeId
    } else {
      return null
    }
  } else {
    return null
  }
}

export function getRoleId(role, rolesList = []) {
  if (rolesList) {
    if (!role) return null
    if (typeof role === 'number') return role

    const uRole = rolesList.find(
      r => new RegExp(role, 'gi').test(r.title)
    )
    if (uRole) {
      return uRole.roleId
    } else {
      return null
    }
  } else {
    return null
  }
}
